// Static empty state for the "AI Actions" list — no pending actions.
export function ActionsEmptyState() {
  return (
    <div className='flex flex-col items-center py-12 px-4 w-full text-center'>
      {/* Anchor icon - nautical theme */}
      <svg
        className='w-20 h-20 mx-auto text-fg-quaternary mb-6'
        viewBox='0 0 64 64'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        {/* Ring / shackle at top */}
        <circle
          cx='32'
          cy='9'
          r='4.5'
          stroke='currentColor'
          strokeWidth='2.5'
          fill='none'
        />
        {/* Vertical shank */}
        <line
          x1='32'
          y1='13.5'
          x2='32'
          y2='48'
          stroke='currentColor'
          strokeWidth='2.5'
          strokeLinecap='round'
        />
        {/* Stock (horizontal crossbar) */}
        <line
          x1='22'
          y1='20'
          x2='42'
          y2='20'
          stroke='currentColor'
          strokeWidth='2.5'
          strokeLinecap='round'
        />
        {/* Arms + crown: a single symmetric sweep (mirrored about x=32) */}
        <path
          d='M14 37C14 49 22 52 32 52C42 52 50 49 50 37'
          stroke='currentColor'
          strokeWidth='2.5'
          strokeLinecap='round'
          fill='none'
        />
        {/* Left fluke barb */}
        <path
          d='M14 37L9 40M14 37L18 41'
          stroke='currentColor'
          strokeWidth='2.5'
          strokeLinecap='round'
          strokeLinejoin='round'
          fill='none'
        />
        {/* Right fluke barb (mirror of left about x=32) */}
        <path
          d='M50 37L55 40M50 37L46 41'
          stroke='currentColor'
          strokeWidth='2.5'
          strokeLinecap='round'
          strokeLinejoin='round'
          fill='none'
        />
      </svg>
      <h3 className='text-lg font-medium text-[var(--color-text-primary)] mb-2'>
        Smooth sailing ahead
      </h3>
      <p className='text-secondary'>
        You're all caught up. No actions need your attention right now.
      </p>
    </div>
  );
}
